import { render, staticRenderFns } from "./Tipomacchina.vue?vue&type=template&id=855457cc&scoped=true&"
import script from "./Tipomacchina.vue?vue&type=script&lang=js&"
export * from "./Tipomacchina.vue?vue&type=script&lang=js&"
import style0 from "./Tipomacchina.vue?vue&type=style&index=0&id=855457cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855457cc",
  null
  
)

export default component.exports